// Функція для додавання свайпера на сторінку
export const injectSwiperAfterEl = (targetElId, sectionId) => {
	const targetSection = getTargetSection(sectionId)
	if (!targetSection) return

	const parentElement = getParentElement(targetElId)
	if (!parentElement) return

	parentElement.after(targetSection)
}

const getTargetSection = sectionId => {
	const targetSection = document.getElementById(sectionId)
	if (!targetSection) return undefined
	return targetSection
}

const getParentElement = elementId => {
	return elementId ? document.getElementById(elementId)?.parentElement : null
}
